module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.component_class
  }, [_c('span', {
    staticClass: "box"
  }, [_c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "item",
    style: ({
      backgroundColor: _vm.color
    })
  })])], 1), _vm._v(" "), _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "id": _vm._uid,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.cur_value
    },
    on: {
      "click": function($event) {
        _vm.triggerHandler(_vm.cur_value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": _vm._uid
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8405f15a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckBox/CheckBox.vue
// module id = 681
// module chunks = 0